import React from 'react';
import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
import UserAccount from '../../services/UserAccount';
import { getCollectionsSubscribed } from '../../services/Pagination';
import LogicBaseCollectionCache from '../../services/cache/LogicBaseCollectionCache';
import WindowSize from '../../services/WindowSize';
import { getCollectionMostFollowers, getCollectionMostRecentlyUpdated, getAllCollectionMostFollowers, getAllCollectionMostRecentlyUpdated, getAllCollectionMostRecentlyCreated } from '../../services/Pagination';
import Scrollable from '../../components/Scrollable';
import Navigation from '../../services/Navigation';
import LogicBaseCollectionRow from '../../components/LogicBaseCollectionRow';
import Popup from '../../services/Popup';
import LogicBaseBanner from '../../components/LogicBaseBanner';
import Button from '../../components/Button';
import FilterBar from '../../components/FilterBar';
import { syncCollectionSubscriptions } from '../../utils/syncDataSets';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const OnlyContentYouSubcribe = styled.div`
  margin-top: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  flex: 1;
  > div {
    box-shadow: ${Constants.CTAShadow};
    padding: 2rem;
    border-radius: 1rem;
    max-width: 420px;
  }
`;

const APPS = {
  'logic': ['68ac548bc77bf010fa57af77', '6836fd1080cc2e312067aed0', '6764b36bd245af2839873075', '6765c78ad245af2839878ae8', '6765b722d245af2839877693', '6765b30bd245af2839877268', '64bd2be9671e7439ff49f9a9', '67c21485b77a2d340049781e'],
  'logictry': ['674ef192453a6702ff950b0b', '68ac63f9c77bf010fa57b364', '68ac5b24c77bf010fa57b121', '6764b36bd245af2839873075', '6765c78ad245af2839878ae8', '6765b722d245af2839877693', '6765b30bd245af2839877268', '67c21485b77a2d340049781e'],
  'sdgs': ['664a9d28b4e8ff3186c37061', '6764b757d245af283987337c', '6764b783d245af28398733ab', '6764b7b5d245af2839873408', '6764b7f1d245af2839873453', '6764b816d245af2839873482', '6764b82cd245af2839873496', '6764b83dd245af28398734a9', '6764b850d245af28398734ca', '6764b861d245af28398734dd', '6764b880d245af28398734ff', '6764b88ed245af2839873512', '6764b89bd245af2839873525', '6764b8aad245af2839873546', '6764b8b6d245af2839873559', '6764b8c3d245af283987356c', '6764b8cfd245af283987357f', '6764b91bd245af28398736c2'],
  'community': ['664a5407a8e1681903c28679', '66e9aa872277c6df8dcbdf88', '657dbae66837722e73eadd11', '64bd1698b20bfa2b228ad089', '657db498a73f67a5614832db'],
  'resources': ['68cb106ae5677fec4e5d3f6a', '68c9b73900a461fe82d9cd5a', '64bc3170fd1d5c1bdba61eb6', '67accafca225d267d6967988', '6782ca103c93165c094526ae', '674ef192453a6702ff950b0b'],
  'volunteering': ['67ad18a6fc7fe117ebe30022'],
  'families': ['680b069c63252802eab15c0c'],
  'teamwater': ['6854103a3feaf86f1500e76f', '688a93ffb9925739b3e48e83', '688ce4047cb1322dd1351536'],
  'wphf': ['67b769054c580a1293c8150f'],
  'artificialintelligence': [],
  'decisionmaking': [],
  'creators': []
};

const FIRST_TOPIC = 'sdgs';

export default class LogicBaseCollectionsPage extends LogictryComponent {
  constructor() {
    super();
    this.collectionMostFollowers = getCollectionMostFollowers('');
    this.collectionMostRecentlyUpdated = getCollectionMostRecentlyUpdated('');
    this.allCollectionMostFollowers = getAllCollectionMostFollowers('');
    this.allCollectionMostRecentlyUpdated = getAllCollectionMostRecentlyUpdated('');
    this.allCollectionMostRecentlyCreated = getAllCollectionMostRecentlyCreated('');
  }
  state = {
    t: Navigation.currentSearch.t,
  }
  componentDidMount() {
    this.collectionMostFollowers.onStateUpdate(this);
    this.collectionMostRecentlyUpdated.onStateUpdate(this);
    this.allCollectionMostFollowers.onStateUpdate(this);
    this.allCollectionMostRecentlyUpdated.onStateUpdate(this);
    this.allCollectionMostRecentlyCreated.onStateUpdate(this);
    LogicBaseCollectionCache.onStateUpdate(this);
    WindowSize.onStateUpdate(this);
    UserAccount.onStateUpdate(this);
  }
  componentWillUnmount() {
    this.collectionMostFollowers.offStateUpdate(this);
    this.collectionMostRecentlyUpdated.offStateUpdate(this);
    this.allCollectionMostFollowers.offStateUpdate(this);
    this.allCollectionMostRecentlyUpdated.offStateUpdate(this);
    this.allCollectionMostRecentlyCreated.offStateUpdate(this);
    LogicBaseCollectionCache.offStateUpdate(this);
    WindowSize.offStateUpdate(this);
    UserAccount.offStateUpdate(this);
    if (this.collectionsSubscribedCache) this.collectionsSubscribedCache.offStateUpdate(this);
  }
  onPagination = () => {
    if (this.collectionsCache && this.collectionsCache.showMore && this.collectionsCache.allFound && this.collectionsCache.initialized) {
      this.collectionsCache.getMore();
      this.forceUpdate();
    }
  }
  navigateTag = (tag, scrollLeft) => {
    if (Constants.isIphone) {
      this.setState({ t: tag });
    } else {
      if (tag === 'home') return Navigation.push(`/`);
      if (!UserAccount.isLoggedIn && tag === FIRST_TOPIC) return Navigation.push(`/`, { 'filterbar_horizontal': scrollLeft });
      return Navigation.push(`${Constants.isIphone ? Navigation.collections : ''}?t=${tag}`, { 'filterbar_horizontal': scrollLeft });
    }
  }
  render() {
    let { t } = this.state;
    const { mobile } = WindowSize;

    this.collectionsCache = null;
    if (UserAccount.isLoggingIn) return;
    let TOPICS = {
      // 'healthcare': 'Healthcare',
      // 'legal': 'Legal',
      'sdgs': 'Sustainable Development Goals',
      'logic': 'Logic & Reasoning',
      // 'decisionmaking': 'Decision Making Frameworks',
      // 'artificialintelligence': 'Artificial Intelligence',
      'resources': 'Helpful Resources',
      'teamwater': '#TeamWater',
      // 'creators': 'Creators',
      'families': 'Families & Next Gens',
      'wphf': 'WPHF',
      'community': 'Community',
      'logictry': 'Logictry',
      'latest': 'Latest',
      'trending': 'Trending',
    };
    if (UserAccount.isDevAccount) TOPICS = { 'allcreated': 'All Created', 'alllatest': 'All Updated', 'alltrending': 'All Trending', ...TOPICS };
    if (UserAccount.isLoggedIn) TOPICS = { 'home': 'Home', ...TOPICS };

    if (!t) {
      t = UserAccount.isLoggedIn ? 'home' : FIRST_TOPIC
    }

    if (t === 'home') {
      if (UserAccount.isLoggedIn) {
        this.collectionsSubscribedCache = getCollectionsSubscribed(UserAccount.account._id);
        this.collectionsSubscribedCache.onStateUpdate(this);
        this.collectionsCache = this.collectionsSubscribedCache;
        const subscriptions = this.collectionsCache.currentPage;
        if (!(!subscriptions || (subscriptions.length === 0 && !this.collectionsCache.allFound))) {
          let subscribedCollections = LogicBaseCollectionCache.getByIds(subscriptions.map(({ collection }) => collection));
          if (subscribedCollections) subscribedCollections = syncCollectionSubscriptions(this.collectionsCache, subscribedCollections);
          this.subscribedCollections = subscribedCollections || this.subscribedCollections;
          this.collections = this.subscribedCollections;
        }
      }
    } else if (t === 'trending') {
      this.collectionsCache = this.collectionMostFollowers;
      this.collections = this.collectionMostFollowers.currentPage;
    } else if (t === 'latest') {
      this.collectionsCache = this.collectionMostRecentlyUpdated;
      this.collections = this.collectionMostRecentlyUpdated.currentPage;
    } else if (t === 'alllatest') {
      this.collectionsCache = this.allCollectionMostRecentlyUpdated;
      this.collections = this.allCollectionMostRecentlyUpdated.currentPage;
    } else if (t === 'alltrending') {
      this.collectionsCache = this.allCollectionMostFollowers;
      this.collections = this.allCollectionMostFollowers.currentPage;
    } else if (t === 'allcreated') {
      this.collectionsCache = this.allCollectionMostRecentlyCreated;
      this.collections = this.allCollectionMostRecentlyCreated.currentPage;
    } else if (APPS[t]) {
      this.collections = LogicBaseCollectionCache.getByIds(APPS[t])?.filter(({ _id }) => _id);
    }
    const tagArray = t && t.split(',') || [];
    return (
      <Scrollable
        vertical
        paginationHeight={400}
        onPagination={this.onPagination}
        adjustForScrollbar
        style={{ position: mobile ? 'relative' : 'absolute', top: 0, left: 0, right: 0, bottom: 0, padding: mobile ? '0 1rem 2rem' : '0 2rem 2rem' }}
        rememberScrollPosition={`logicbasecollections`}
        onScroll={() => {
          Popup.clearApp();
        }}
      >
        <div>
          <LogicBaseBanner tag={t} />
        </div>
        <div style={{ marginTop: '1.5rem' }}>
          <FilterBar
            allTopics={TOPICS}
            selectedTopics={tagArray}
            onTopicSelected={this.navigateTag}
          />
        </div>
        {this.collections && (this.collections.length === 0 && t === 'home' && <OnlyContentYouSubcribe>
          <div>
            <h1>Collections Subscribed</h1>
            <p>Your home page shows you the collections you have subscribed to and nothing more!</p>
            <br></br>
            <Button onClick={() => {
              Navigation.push(`${Constants.isIphone ? Navigation.collections : ''}?t=${FIRST_TOPIC}`)
            }} filledColor>
              <span>Click to Discover</span>
            </Button>
          </div>
        </OnlyContentYouSubcribe> || <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '2rem', paddingBottom: '4rem' }}>
          {this.collections.map((collection) => <LogicBaseCollectionRow
            key={collection._id}
            collection={collection}
          />)}
        </div>)}
      </Scrollable>
    );
  }
}
